import React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
const SearchReset = (props) => (<Svg viewBox="0 0 20 20" fill="none" {...props}>
    <Rect width={20} height={20} rx={10} fill="#DDDFE9"/>
    <Path d="M12.8569 7.14307L7.14258 12.8574" stroke="#393360" strokeWidth={1.42857} strokeLinecap="round" strokeLinejoin="round"/>
    <Path d="M7.14258 7.14307L12.8569 12.8574" stroke="#393360" strokeWidth={1.42857} strokeLinecap="round" strokeLinejoin="round"/>
  </Svg>);
export default SearchReset;
